import React from "react";
import { Carousel, Card, Container } from "react-bootstrap";
import "./Signup.css";
import Img1 from "../../assets/images/login/Img1.png";
import Img2 from "../../assets/images/login/Img2.png";
import Img3 from "../../assets/images/login/Img3.png";
import Img4 from "../../assets/images/login/Img4.png";
import Img5 from "../../assets/images/login/Img5.png";
import logo from "../../assets/images/login/Nathicharami Logo.png";
import cornerImg from "../../assets/images/login/corner.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import Select from "react-select";
import { axiosInstance } from "../../axiosInstance";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
// import Preloader from "../../Components/Preloader/Preloader";
import { useState } from "react";
import Preloader from "../../Components/Loader/Loader";

// const options = [
//   { value: "Match Maker", label: "Match Maker" },
//   { value: "Photographer", label: "Photographer", isDisabled: true },
//   { value: "Beautician", label: "Beautician", isDisabled: true },
//   {
//     value: "Event Hall Manager",
//     label: "Event Hall Manager",
//     isDisabled: true,
//   },
// ];
const SignupSchema = object({
  email: string().email("should include @").required("Please enter email"),
  category: string().required("Please select a category"),
  first_name: string().required("Please enter your first name"),
  agency_name: string().required("Please enter your  agency name"),
});

export function Signup() {
  const [loading, setLoading] = useState(false);
  const phoneNumber = localStorage.getItem("phoneNumber");
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      category: "Match Maker",
      first_name: "",
      last_name: "",
      email: "",
      agency_name: "",
    },
    validationSchema: SignupSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const formattedValues = {
          ...values,
        };

        const response = await axiosInstance.put("profile", formattedValues);
        console.log("Response:", response);
        if (response.data.status === true) {
          setLoading(false);
          toast.success(response.data.message || "Register Successfully!");
          resetForm();

          setTimeout(() => {
            navigate("/home");
          }, 2000);
        } else {
          setLoading(false);
          toast.error(response.data.message || "Email already exist");
        }
      } catch (error) {
        setLoading(false);
        console.error("Submission failed:", error);
        toast.error(
          "Profile update failed,This email is already in use. Please use a different one."
        );
      }
    },
  });
  return (
    <>
      <ToastContainer />
      {loading && <Preloader />}
      <div className="signupContainer">
        <div className="loginLeft">
          <Carousel className="carousel">
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img1} />
                  </div>
                  <div className="carousel-title">Create Perfect Matches</div>
                  <div className="carousel-desc">
                    Join Nathicharami’s trusted network of matchmaking
                    professionals.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img2} />
                  </div>
                  <div className="carousel-title">Capture Love Stories</div>
                  <div className="carousel-desc">
                    Connect with couples seeking timeless wedding memories.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img3} />
                  </div>
                  <div className="carousel-title">Enhance Bridal Radiance</div>
                  <div className="carousel-desc">
                    List your services and get booked by brides and grooms.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img4} />
                  </div>
                  <div className="carousel-title">Spread the Love</div>
                  <div className="carousel-desc">
                    Promote Nathicharami and earn rewards for every successful
                    match.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img5} />
                  </div>
                  <div className="carousel-title">
                    Host Unforgettable Weddings
                  </div>
                  <div className="carousel-desc">
                    Showcase your venue to couples dreaming of their perfect
                    wedding.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
          </Carousel>
        </div>
        <div className="login-right">
          <form onSubmit={formik.handleSubmit}>
            <div className="loginLogo">
              <img src={logo} />
            </div>
            <div className="loginRight-text">Registration</div>
            <div className="registerInput">
              {/* <div>
                <label>Select Profession</label>{" "}
                <span className="text-danger">*</span>
              </div> */}
              {/* <div>
                <span>
                  <Select
                    placeholder="Select"
                    options={options}
                    isSearchable={false}
                    value={options.find(
                      (option) => option.value === formik.values.category
                    )} //for formik
                    onChange={(selectedOption) =>
                      formik.setFieldValue("category", selectedOption.value)
                    } //for formik
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        width: "100%",
                        minHeight: "40px",
                        height: "40px",
                        borderColor: "#E4E4E4",
                        backgroundColor: "#FAFAFA",
                        borderRadius: "10px",
                        borderColor: state.isFocused
                          ? "#E4E4E4"
                          : base.borderColor,
                        boxShadow: state.isFocused ? "#E4E4E4" : base.boxShadow,
                        "&:hover": {
                          borderColor: "#E4E4E4",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused
                          ? "#FEECF0"
                          : state.isSelected
                          ? "transparent"
                          : "transparent",
                        color: "#707070",
                        cursor: "pointer",
                        ":active": {
                          backgroundColor: "#FEECF0", // fixes the blue flicker when selecting
                        },
                      }),

                      menu: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }),
                    }}
                  />
                  {formik.touched.category && formik.errors.category && (
                    <div className="text-danger">{formik.errors.category}</div>
                  )}
                </span>
              </div> */}
              <div>
                <label for="category">Category</label>{" "}
                <span className="text-danger">*</span>
              </div>
              <input
                type="text"
                id="category"
                name="category"
                value={formik.values.category}
                disabled
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.category && formik.errors.category && (
                <div className="text-danger">{formik.errors.category}</div>
              )}
            </div>
            <div className="registerInput">
              <div>
                {" "}
                <label for="first_name">First Name</label>{" "}
                <span className="text-danger">*</span>
              </div>
              <input
                type="text"
                id="first_name"
                value={formik.values.first_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.first_name && formik.errors.first_name && (
                <div className="text-danger">{formik.errors.first_name}</div>
              )}
            </div>
            <div className="registerInput">
              <div>
                {" "}
                <label for="last_name">Last Name</label>
              </div>
              <input
                type="text"
                id="last_name"
                value={formik.values.last_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            <div className="registerInput">
              <div>
                {" "}
                <label for="agency_name">Agency Name</label>{" "}
                <span className="text-danger">*</span>
              </div>
              <input
                type="text"
                id="agency_name"
                value={formik.values.agency_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.agency_name && formik.errors.agency_name && (
                <div className="text-danger">{formik.errors.agency_name}</div>
              )}
            </div>
            <div className="registerInput">
              <div>
                {" "}
                <label for="email">Email</label>{" "}
                <span className="text-danger">*</span>
              </div>
              <input
                type="email"
                id="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <div className="text-danger">{formik.errors.email}</div>
              )}
            </div>
            <div className="registerInput">
              <div>
                {" "}
                <label>Phone Number</label>
              </div>
              <input type="text" disabled value={phoneNumber} />
            </div>

            <div className="btnSend">
              <button type="submit">Submit</button>
            </div>
            <div className="already-text">
              Already have an Account?{" "}
              <Link to="/" style={{ color: "#F24464", textDecoration: "none" }}>
                Login
              </Link>
            </div>
          </form>
        </div>
        <div className="cornerImg">
          <img src={cornerImg} />
        </div>
      </div>
    </>
  );
}
